import { produce } from 'immer';
import { create, SetState } from 'zustand';
import { ModalAction, ModalStore, ModalType, useModalState } from '~/types';

const initialModalState = (): useModalState => ({
  type: 'double_red' as ModalType,
  isOpen: false,
  title: '',
  content: '',
  buttonName: '',
  leftButtonName: '',
});

const ModalActions = (set: SetState<ModalStore>): ModalAction => ({
  setModalState: (newState: useModalState) =>
    set(
      produce((state) => {
        state.type = newState.type;
        state.isOpen = newState.isOpen;
        state.title = newState.title;
        state.content = newState.content;
        state.click = newState.click;
        state.cancelClick = newState.cancelClick;
        state.buttonName = newState.buttonName;
        state.leftButtonName = newState.leftButtonName;
      }),
    ),
});

const useModalStore = create<ModalStore>((set) => ({
  ...initialModalState(),
  ...ModalActions(set),
}));

export default useModalStore;
